import React, { useMemo } from "react"
import useDebounceQueryParams from "magik-react-hooks/useRouterDebounceQueryParams"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import Layout from "../../components/Layout/Layout"
import ModalDelete from "../../components/Modals/ModalDelete"
import ListUtenti from "../../components/Utenti/ListUtenti"
import { UtenteState } from "../../state/utenti"
import { AddCircle, Cancel, GetApp, RotateLeft } from "@material-ui/icons"
import {
  Card,
  TextField,
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  IconButton,
} from "@material-ui/core"
import ModalFormUtente from "../../components/Utenti/ModalFormUtente"
import { useRunRj } from "react-rocketjump"
import qs from "query-string"
import { useExportToken } from "../../state/exportToken"
import { useSelectedAzienda } from "../../SelectedAzienda"
import { isMobile } from "react-device-detect"

export default function Utenti() {
  const [{ selectedAzienda }] = useSelectedAzienda()
  const [
    queryParams,
    setQueryParams,
    debQueryParams,
    setDebQueryParams,
  ] = useDebounceQueryParams()

  const [modalCreate, actionsModalCreate] = useModalTrigger()
  const [modalUpdate, actionsModalUpdate] = useModalTrigger()
  const [modalDelete, actionsModalDelete] = useModalTrigger()
  const { value: deleteUtente } = modalDelete

  const onUpdate = (servizio) => actionsModalUpdate.open(servizio)
  const onDelete = (servizio) => actionsModalDelete.open(servizio)

  const filters = useMemo(() => {
    return { ...debQueryParams, azienda: selectedAzienda.id }
  }, [debQueryParams, selectedAzienda.id])

  const [
    { list, loading, pagination, allCount },
    { addUtente, updateUtente, removeUtente, run: fetchUtenti },
  ] = useRunRj(UtenteState, [filters], false)

  const columnProps = {
    value: queryParams.ordering,
    onChange: (value) => setDebQueryParams({ ordering: value }),
  }

  const isProductionEnv = process.env.NODE_ENV === "production"
  const host = isProductionEnv ? window.location.host : "localhost:8000"
  const protocol = window.location.protocol

  const exportToken = useExportToken()

  const linkCsv = useMemo(() => {
    return `${protocol}//${host}/api/utenti-export/csv?${qs.stringify({
      ...filters,
      export_token: exportToken,
    })}`
  }, [exportToken, filters, host, protocol])

  return (
    <Layout title="Utenti">
      <div>
        <Card className="card-filters">
          <Grid container>
            <Grid xs={12} md={6}>
              <div>
                <TextField
                  size="small"
                  placeholder="Cerca..."
                  value={queryParams.search ?? ""}
                  onChange={(e) =>
                    setDebQueryParams({
                      search: e.target.value,
                      page: 1,
                    })
                  }
                  style={{ width: isMobile ? '100%' : undefined}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          disabled={!queryParams.search}
                          aria-label="toggle password visibility"
                          onClick={() => setQueryParams(() => {})}
                          edge="end"
                        >
                          <Cancel
                            color={!queryParams.search ? undefined : "primary"}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  id="outlined-basic"
                  variant="outlined"
                />
              </div>
            </Grid>
            <Grid md={6} xs={12}>
              <div
                className={
                  isMobile ? "d-flex justify-content-center pt-5" : "text-right"
                }
              >
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<GetApp />}
                  href={linkCsv}
                >
                  Excel
                </Button>
                {/* <Button
                  style={{ marginLeft: 10 }}
                  variant="contained"
                  color="primary"
                  target="_blank"
                  startIcon={<GetApp />}
                  href={linkPdf}
                >
                  Pdf
                </Button> */}
              </div>
            </Grid>
          </Grid>
        </Card>
        <Card className="card-add">
          <Button
            variant="contained"
            color="primary"
            disabled={
              allCount === null
                ? true
                : allCount >= selectedAzienda.numero_licenze
            }
            startIcon={<AddCircle />}
            onClick={() => actionsModalCreate.open()}
          >
            Aggiungi Utente
          </Button>
        </Card>
        {list === null && loading && (
          <div style={{ textAlign: "center" }}>
            <CircularProgress color="primary" />
          </div>
        )}
        {list && (
          <ListUtenti
            columnProps={columnProps}
            pagination={pagination}
            utenti={list}
            onUpdate={onUpdate}
            onDelete={onDelete}
          />
        )}
        <ModalFormUtente
          save={(utente) => {
            return addUtente
              .onSuccess(() => {
                actionsModalCreate.close()
                fetchUtenti(filters)
              })
              .asPromise({
                ...utente,
                profilo: {
                  permessi: utente.profilo.permessi,
                  aziende_visibili: [selectedAzienda.id],
                },
              })
          }}
          isOpen={modalCreate.isOpen}
          toggle={actionsModalCreate.toggle}
          onExited={actionsModalCreate.onClosed}
        />
        <ModalFormUtente
          save={(utente) => {
            return updateUtente
              .onSuccess(() => actionsModalUpdate.close())
              .asPromise(utente)
          }}
          utente={modalUpdate.value}
          isOpen={modalUpdate.isOpen}
          toggle={actionsModalUpdate.toggle}
          onExited={() => {
            actionsModalUpdate.onClosed()
          }}
        />
        <ModalDelete
          isOpen={modalDelete.isOpen}
          toggle={actionsModalDelete.toggle}
          title={deleteUtente ? `Rimuovere utente?` : null}
          text={deleteUtente ? `Sei sicuro di voler eliminare l'utente?` : null}
          onDelete={() => {
            return removeUtente
              .onSuccess(() => {
                actionsModalDelete.close()
                fetchUtenti(filters)
              })
              .asPromise(modalDelete.value)
          }}
          onExited={() => {
            actionsModalDelete.onClosed()
          }}
        />
      </div>
    </Layout>
  )
}
